<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <div class="h-full flex flex-col ">
    <div class="mb-3 flex items-center gap-3">
      <button [disabled]="isReadOnly()" (click)="onAdd()" pButton type="button" label="Add Rule for This Program"
        icon="pi pi-plus" class="p-button-sm"></button>
      <span class="text-sm text-gray-700">
        Every Claude rule that applies to this program. Rules for this program are edited here; broader rules on
        Utilities &gt; Guidelines. To replace a broader rule here, list it in Overrides.
      </span>
    </div>
    <div class="grow">
      <prox-ag-grid [gridOptions]="gridOptions" [rowData]="guidelines"></prox-ag-grid>
    </div>
  </div>
</div>
